<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData" ref="form" label-width="120px" v-loading="loading">
        <el-row :span="24">
          <el-col :span="12">
            <el-form-item prop="objNum" label="工单编号">
              {{ formData.objNum || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="sourceType" label="来源类型">
              {{ formData.sourceType || '--' }}
            </el-form-item>
          </el-col>

          <!-- 新增：绩效类型 放在客户名称上方 -->
          <el-col :span="12">
            <el-form-item prop="performanceType" label="绩效类型">
              {{ getPerformanceTypeName(formData.performanceType) }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item :label="formData.performanceType === '3' ? '调拨客户名称' : '客户名称'" prop="userName">
              {{ formData.userName || '--' }}
            </el-form-item>
          </el-col>
          <!-- 调拨才显示接收客户 -->
          <el-col :span="12" v-if="formData.performanceType === '3'">
            <el-form-item prop="receiveUserName" label="接收客户名称">
              {{ formData.receiveUserName || '--' }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item prop="specName" label="品种规格">
              {{ formData.specName || '--' }}
            </el-form-item>
          </el-col>

          <el-col :span="12" v-if="formData.performanceType !== '3'">
            <el-form-item prop="warehouseName" label="关联仓库">
              {{ formData.warehouseName || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="formData.performanceType === '3'">
            <el-form-item prop="warehouseName" label="调拨仓库">
              {{ formData.warehouseName || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="formData.performanceType === '3'">
            <el-form-item prop="receiveWarehouseName" label="接收仓库">
              {{ formData.receiveWarehouseName || '--' }}
            </el-form-item>
          </el-col>

          <!-- 出库、入库展示车牌号 -->
          <el-col :span="12" v-if="formData.performanceType === '1' || formData.performanceType === '2'">
            <el-form-item prop="vehicleKey" label="车牌号">
              {{ formData.vehicleKey || '--' }}
            </el-form-item>
          </el-col>

          <!-- 出库：计划发货数量 -->
          <el-col :span="12" v-if="formData.performanceType === '2'">
            <el-form-item prop="planQuantity" label="计划发货数量">
              {{ formData.planQuantity || '--' }}
            </el-form-item>
          </el-col>

          <!-- 出库、入库：实际发货数量 -->
          <el-col :span="12" v-if="formData.performanceType === '1' || formData.performanceType === '2'">
            <el-form-item prop="addQuantity" label="实际发货数量">
              {{ formData.addQuantity || '--' }}
            </el-form-item>
          </el-col>

          <!-- 入库：实际收货数量 -->
          <el-col :span="12" v-if="formData.performanceType === '1'">
            <el-form-item prop="trueQuantity" label="实际收货数量">
              {{ formData.trueQuantity || '--' }}
            </el-form-item>
          </el-col>

          <!-- 调拨：调拨数量 -->
          <el-col :span="12" v-if="formData.performanceType === '3'">
            <el-form-item prop="transferQuantity" label="调拨数量">
              {{ formData.transferQuantity || '--' }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item prop="performanceCoefficient" label="绩效系数">
              {{ formData.performanceCoefficient || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="performancePrice" label="绩效">
              {{ formData.performancePrice != null ? Number(formData.performancePrice).toFixed(2) : '--' }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item prop="ctime" label="创建时间">
              {{ formData.ctime || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="utime" label="更新时间">
              {{ formData.utime || '--' }}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">返回</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>
export default {
  name: 'JxCountDetail',
  data() {
    return {
      formData: {
        id: '',
        wareRecId: '',
        objId: '',
        objNum: '',
        sourceType: '',
        performanceType: null,
        userId: '',
        userName: '',
        receiveUserId: '',
        receiveUserName: '',
        specId: '',
        specName: '',
        warehouseId: '',
        warehouseName: '',
        receiveWarehouseId: '',
        receiveWarehouseName: '',
        vehicleKey: '',
        planQuantity: '',
        addQuantity: '',
        trueQuantity: '',
        transferQuantity: '',
        performanceCoefficient: '',
        performancePrice: '',
        createUserId: '',
        ctime: '',
        utime: ''
      },
      loading: false
    }
  },
  created() {
    if (this.$route.query.id) {
      this.loadData()
    }
  },
  methods: {
    getPerformanceTypeName(type) {
      const map = {
        1: '入库绩效',
        2: '出库绩效',
        3: '货转调拨绩效'
      }
      return map[Number(type)] || '--'
    },
    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.performance.selectYgPerformanceById, {
        params: {
          id: this.$route.query.id
        }
      }).then(res => {
        this.formData = res
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-form {
  .el-input-number,
  .el-select,
  .el-input,
  .el-cascader,
  .el-date-editor {
    width: 100%;
    max-width: 400px;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}
</style>
